import { SessionStorageService } from "./SessionStorageService";

export const LocalStorageService = {

    set: (key, value, config = {}) => {
        let a;
        let val = config.ttl && config.ttl > 0 ? (a = {}, a['data'] = value, a.ttl = Date.now() + config.ttl * 1e3, a) : value
        localStorage.setItem(key, JSON.stringify(val));
    },
    clear: () => {
        localStorage.clear();
        SessionStorageService.clear();
    },
    remove: (key) => {
        localStorage.removeItem(key);
    },
    get: (key) => {
        let str = localStorage.getItem(key);
        if(!str){
            return null
        }
        let item = JSON.parse(str);
        let hasTTL = typeof item === 'object' && 'data' in item;
        if(!hasTTL){
            return item
        }
        if (Date.now() > item.ttl) {
            localStorage.removeItem(key);
            return null;
        }
        return item['data'];
    },

    // getRemote: (event) => {
    //     const { action, key, value } = event.data
    //     if (action == 'returnData') {
    //         useData(key, value)
    //     }
    // },
    setRemote: (key, value) => {
        const iframe = document.getElementById('rls')
        iframe.contentWindow.postMessage({
            action: 'save',
            key,
            value
        }, "*")
    },
}
